import { faBarcode, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { FroalaEditor } from "../../../../Components/CardsPages/Forms/Editor/FroalaEditor";
import LazySelect from "../../../../Components/CardsPages/Forms/LazySelect";
import SpinnerComponent from "../../../../Components/Loding/Spinner";
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import { useHistoricoContext } from "../../../../Context/Historico";
// import { useUserInfor } from "../../../../Context/User";
import { BaixarExtratoIrpfPDFController } from "../../../../Controllers/Cobranca/Extrato/ExtratoController";
import { ListarContatosController } from "../../../../Controllers/Geral/Contatos/ContatosController";
import {
    GetDocumentoTemplateController,
    ListarDocumentoTemplateController,
    SetVariaveisDocumentoController,
} from "../../../../Controllers/Geral/Documentos/DocumentosController";
import { EnviarEmailAnexoController } from "../../../../Controllers/Geral/Email/EmailController";
import { ListarEmailContaPorUsuarioController } from "../../../../Controllers/Geral/Grupos/GruposEmailsController";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { IAtendimentoDetalhadoCobranca } from "../../../../Interfaces/Cobranca/GestaoAtendimento/GestaoAtendimentoInterface";
import { ACESSOS } from "../../../../Routes/Acessos";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";

interface IFormData {
    email_destinatario: string;
    email_remetente: number;
    assunto: string;
    file: Array<File>;
    cc: string;
    cco: string;
    ModeloEmail: number;
    NR_ANO: number;
    DS_MENSAGEM: string;
}

interface IAnoForm {
    NR_ANO: number;
}
interface IExtratoIRPfProps {
    Atendimento: IAtendimentoDetalhadoCobranca;
    setShow: (show: boolean) => void;
}

export function ExtratoIRPf(props: IExtratoIRPfProps) {
    const { ReloadHistorico } = useHistoricoContext();
    // const { OrgInfor } = useUserInfor();

    const form1 = useForm();
    const form2 = useForm();
    const setValueForm1 = form1.setValue;
    const setValueForm2 = form2.setValue;
    const [buttonSpinner, setButtonSpinner] = useState(false);
    const [ButtonDisable, setButtonDisable] = useState(false);
    const [idDocumentoTemplate, setIdDocumentoTemplate] = useState(0);
    const [Loading, setLoading] = useState(false);
    const [AnoBase, setAnoBase] = useState(() => {
        const anoAnterior = new Date();
        anoAnterior.setFullYear(anoAnterior.getFullYear() - 1);
        return anoAnterior.getFullYear();
    });
    const [pdf, setpdf] = useState<string>();
    const { idModulo } = useAtendimentoPage();
    
    // const [uploading, setUploading] = useState(false);
    // const [uploadedImages, setUploadedImages] = useState<string[]>([]);
    
    // const siengeMode = OrgInfor.COD_ERP_INTEGRACAO === "SIENGE";
    
    useEffect(() => {
        ListarContatosController(props.Atendimento.ID_CONTA).then((res) => {
            setValueForm1("email_destinatario", res[0].DS_EMAIL);
        });
        
        const AnoAnterior = new Date();
        AnoAnterior.setFullYear(AnoAnterior.getFullYear() - 1);
        

        setValueForm2("NR_ANO", AnoAnterior.getFullYear());
    }, [props.Atendimento.ID_CONTA, setValueForm1, setValueForm2]);

    const { execute: listarDocumentosTemplateSimples } = useAsyncCallback(
        () => ListarDocumentoTemplateController({ idTipoCaso: idModulo }),
        []
    );

    const { value: documentoTemplate } = useAsyncEffect(
        () => GetDocumentoTemplateController(idDocumentoTemplate),
        [idDocumentoTemplate]
    );

    useEffect(() => {
        if (AnoBase > 0) {
            BaixarExtratoIrpfPDFController({
                ID_EMPRESA: props.Atendimento.ID_EMPRESA,
                ID_OBRA: props.Atendimento.DS_OBRA,
                ID_VENDA: props.Atendimento.NR_VENDA,
                NR_ANO: AnoBase,
            }).then((res) => {
                const obj = document.createElement("object");
                obj.style.width = "100%";
                obj.style.height = "842pt";
                obj.type = "application/pdf";
                obj.data = "data:application/pdf;base64," + res;
                setpdf("data:application/pdf;base64," + res);
            });
        }
    }, [
        AnoBase,
        props.Atendimento.ID_EMPRESA,
        props.Atendimento.DS_OBRA,
        props.Atendimento.NR_VENDA,
        // siengeMode,
    ]);

    function handleFormSubmit(formData: IAnoForm) {
        setButtonSpinner(true);
        BaixarExtratoIrpfPDFController({
            ID_EMPRESA: props.Atendimento.ID_EMPRESA,
            ID_OBRA: props.Atendimento.DS_OBRA,
            ID_VENDA: props.Atendimento.NR_VENDA,
            NR_ANO: formData.NR_ANO,
        })
            .then((res) => {
                setpdf("data:application/pdf;base64," + res);
                setButtonSpinner(false);
            })
            .catch(() => {
                setButtonSpinner(false);
            });
    }

    function handleInserirCasoFormSubmit(formData: IFormData) {
        // if (siengeMode) {
        //     BaixarExtratoIrpfPDFController({
        //         ID_EMPRESA: props.Atendimento.ID_EMPRESA,
        //         ID_OBRA: props.Atendimento.DS_OBRA,
        //         ID_VENDA: props.Atendimento.NR_VENDA,
        //         NR_ANO: AnoBase,
        //         DS_ASSUNTO: formData.assunto,
        //         DS_MENSAGEM: formData.DS_MENSAGEM,
        //     })
        //         .then((res) => {
        //             ReloadHistorico();
        //             props.setShow(false);
        //         })
        //         .finally(() => {
        //             setLoading(false);
        //         });
        // } else {
        setLoading(true);
        BaixarExtratoIrpfPDFController({
            ID_EMPRESA: props.Atendimento.ID_EMPRESA,
            ID_OBRA: props.Atendimento.DS_OBRA,
            ID_VENDA: props.Atendimento.NR_VENDA,
            NR_ANO: AnoBase,
        })
            .then(async (base64) => {
                return fetch(`data:application/pdf;base64,${base64}`).then(
                    (r) => r.blob()
                );
            })
            .then((blob) => {
                const file = new File([blob], "Extrato.pdf", {
                    type: "application/pdf",
                });

                if (file) {
                    EnviarEmailAnexoController({
                        File: [file],
                        DS_ASSUNTO: formData.assunto,
                        DS_MENSAGEM: formData.DS_MENSAGEM,
                        ID_CASO: props.Atendimento.ID_CASO,
                        ID_EMAIL_CONTA: formData.email_remetente,
                        DS_DESTINATARIO: formData.email_destinatario,
                        DS_COPIA_CARBONO: formData.cc,
                        DS_COPIA_CARBONO_OCULTA: formData.cco,
                    })
                        .then((res) => {
                            ReloadHistorico();
                            props.setShow(false);
                        })
                        .catch(() => {
                            setLoading(false);
                        });
                }
            });
        // }
    }
    return (
        <div className="col-12">
            <form
                onSubmit={form1.handleSubmit(handleInserirCasoFormSubmit)}
                className="w-100 align-itens-center mt-5"
            >
                {/* {!siengeMode && ( */}
                <>
                    <div className="row d-flex flex-wrap">
                        <div className="col-12 col-lg-6 mt-2">
                            <LazySelect
                                label="Email Remetente:"
                                name="email_remetente"
                                className={`form-control placeholder-dark-50  ${
                                    form1.formState.errors.email_remetente &&
                                    "is-invalid"
                                }`}
                                ref={form1.register({
                                    required: "Insira o email",
                                    valueAsNumber: true,
                                })}
                                controller={
                                    ListarEmailContaPorUsuarioController
                                }
                                getDS={(ec) => ec.DS_REMETENTE}
                                getKeyValue={(ec) => ec.ID_EMAIL_CONTA}
                            />
                        </div>

                        <div className="col-12 col-lg-6 mt-2">
                            <label>Email Destinatário:</label>
                            <input
                                type="text"
                                name="email_destinatario"
                                placeholder={"Digite o email"}
                                className={`form-control px-0 p-2 placeholder-muted-75  ${
                                    form1.formState.errors.email_destinatario &&
                                    "is-invalid"
                                }`}
                                ref={form1.register({
                                    required: "Insira o email",
                                })}
                            />
                        </div>
                    </div>
                    <div className="row mb-3 d-flex flex-wrap">
                        <div className="col-12 col-lg-6 mt-2">
                            <label>Cópia Carbono:</label>
                            <input
                                type="text"
                                name="cc"
                                placeholder={"Digite o email para cópia"}
                                className={`form-control px-0 p-2 placeholder-muted-75`}
                                ref={form1.register()}
                            />
                        </div>

                        <div className="col-12 col-lg-6 mt-2">
                            <label>Cópia Carbono Oculta:</label>
                            <input
                                type="text"
                                name="cco"
                                placeholder={"Digite o email para cópia oculta"}
                                className={`form-control px-0 p-2 placeholder-muted-75`}
                                ref={form1.register()}
                            />
                        </div>
                    </div>
                </>
                {/* )} */}

                <div className="row mb-3 d-flex flex-wrap">
                    <div className="col-12 col-lg-6">
                        <label>Assunto:</label>
                        <input
                            type="text"
                            name="assunto"
                            placeholder="Assunto:"
                            className={`form-control px-0 p-2 placeholder-muted-75 ${
                                form1.formState.errors.assunto && "is-invalid"
                            }`}
                            defaultValue={documentoTemplate?.DS_ASSUNTO}
                            ref={form1.register({
                                required: "",
                            })}
                        />
                    </div>
                    <div className="col-12 col-lg-6">
                        <LazySelect
                            label="Template de Email:"
                            className={`form-control placeholder-dark-50  ${
                                form1.formState.errors.ID_MODELO_EMAIL &&
                                "is-invalid"
                            }`}
                            name="ModeloEmail"
                            ref={form1.register({
                                valueAsNumber: true,
                            })}
                            onChange={(e) => {
                                if (e && props.Atendimento.ID_CASO) {
                                    setIdDocumentoTemplate(
                                        Number(e.target.value)
                                    );
                                    setButtonDisable(true);
                                    SetVariaveisDocumentoController(
                                        Number.parseInt(e.target.value),
                                        props.Atendimento.ID_CASO,
                                        ACESSOS.ATENDIMENTO.ID_MODULO
                                    )
                                        .then((res) => {
                                            form1.setValue("DS_MENSAGEM", res);
                                            setButtonDisable(false);
                                        })
                                        .catch(() => {
                                            setButtonDisable(false);
                                        });
                                }
                            }}
                            controller={listarDocumentosTemplateSimples}
                            getDS={(dt) => dt.DS_DOCUMENTO}
                            getKeyValue={(dt) => dt.ID_DOCUMENTO_TEMPLATE}
                        >
                            <option>Modelo de email</option>
                        </LazySelect>
                    </div>

                    <div className="col-12 h-100 mt-4">
                        <Controller
                            name="DS_MENSAGEM"
                            defaultValue=""
                            control={form1.control}
                            render={(field) => (
                                <>
                                    {/* {uploading && (
                                        <div className="d-flex align-items-center justify-content-center g-2 p-2">
                                            Fazendo upload de imagem{" "}
                                            <Spinner
                                                size="sm"
                                                color="primary"
                                            />
                                        </div>
                                    )} */}

                                    <FroalaEditor
                                        value={field.value ?? ""}
                                        onChange={field.onChange}
                                        onImageUploadStart={() => false}
                                        onImageUploadEnd={() => false}
                                    />
                                </>
                            )}
                        />
                    </div>
                </div>
                <div className="mb-3 d-flex flex-wrap">
                    {Loading ? (
                        <button
                            type="button"
                            className="btn btn-sm btn-shadow btn-primary m-1"
                        >
                            <div className="row px-4">
                                <div className="loading-component">
                                    <div
                                        className="spinner-border spinner-border-sm text-light"
                                        role="status"
                                    >
                                        <span className="sr-only">
                                            Carregando...
                                        </span>
                                    </div>
                                </div>
                                <div className="ml-2">
                                    Enviar Extrato por Email
                                </div>
                            </div>
                        </button>
                    ) : (
                        <button
                            className="btn btn-sm btn-shadow btn-primary m-1"
                            disabled={!!ButtonDisable}
                        >
                            <FontAwesomeIcon
                                icon={faPaperPlane}
                                size="lg"
                                className="mr-1"
                            />{" "}
                            Enviar Extrato por Email
                        </button>
                    )}
                </div>
            </form>
            {/* {!siengeMode && ( */}
            <form
                onSubmit={form2.handleSubmit(handleFormSubmit)}
                className="w-100 align-itens-center mt-5"
            >
                <div className="d-flex col-12 col-lg-8 mb-3 d-flex flex-wrap p-1">
                    <input
                        ref={form2.register({
                            required: "Insira o ano base",
                            valueAsNumber: true,
                        })}
                        defaultValue={AnoBase}
                        type="text"
                        name={"NR_ANO"}
                        placeholder="Digite o ano base"
                        className={`form-control w-50 px-0 p-2 mr-5 placeholder-dark-75 ${
                            form2.formState.errors.NR_ANO && "is-invalid"
                        }`}
                        onChange={(e) => setAnoBase(Number(e.target.value))}
                    />

                    {!buttonSpinner ? (
                        <button className="btn btn-sm btn-shadow btn-primary m-1">
                            <div className="toClick-component">
                                <FontAwesomeIcon
                                    icon={faBarcode}
                                    className="mr-2"
                                />{" "}
                                Gerar Extrato IR
                            </div>
                        </button>
                    ) : (
                        <button className="btn btn-sm btn-shadow btn-primary m-1">
                            <div className="loading-component">
                                <div
                                    className="spinner-border spinner-border-sm text-light"
                                    role="status"
                                >
                                    <span className="sr-only">
                                        Carregando...
                                    </span>
                                </div>
                            </div>
                        </button>
                    )}
                </div>
                <div className="col-12">
                    <div className="d-flex justify-content-start align-items-center mt-6">
                        {pdf && AnoBase !== 0 ? (
                            <object
                                type="application/pdf"
                                data={pdf}
                                style={{ width: "100%", height: "300px" }}
                            >
                                Extrato IRPF em PDF
                            </object>
                        ) : (
                            <SpinnerComponent />
                        )}
                    </div>
                </div>
            </form>
            {/* )} */}
            <a
                href="/#"
                id="abrirBase64"
                target="_blank"
                className="d-none"
                download={"download"}
            >
                Link
            </a>
        </div>
    );
}
